import TemplateRoutes from "./components/TemplateRoutes/TemplateRoutes";
import ThemeContext, { themeDefaults } from "./contexts/ThemeContext";
import { ToastContainer } from 'react-toastify';
import { injectThemeCSS } from "./utils/themeToCSS";
import { useLayoutEffect } from "react";

const themeSettings = {
  ...themeDefaults,
  // You can override any theme values here
  // For example:
  // colors: {
  //   ...themeDefaults.colors,
  //   primary: {
  //     ...themeDefaults.colors.primary,
  //     500: '#your-custom-color'
  //   }
  // }
};

function App() {
  // Inject CSS custom properties on app load
  useLayoutEffect(() => {
    injectThemeCSS();
  }, []);

  return (
    <div className="App">
      <ToastContainer />
      <ThemeContext.Provider value={themeSettings}>
        <TemplateRoutes />
      </ThemeContext.Provider>
    </div>
  );
}

export default App;
